import { render, staticRenderFns } from "./adminPlane.vue?vue&type=template&id=35fa6338&scoped=true"
import script from "./adminPlane.vue?vue&type=script&lang=js"
export * from "./adminPlane.vue?vue&type=script&lang=js"
import style0 from "./adminPlane.vue?vue&type=style&index=0&id=35fa6338&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fa6338",
  null
  
)

export default component.exports